import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table   : 'CI_VSET',
    fieldMap: {
        id              : 'CIVS_ID',
        statusId        : 'CIVS_CIST_ID',
        origin          : 'CIVS_ORIGIN',
        module          : 'CIVS_MODULE',
        name            : 'CIVS_NAME',
        description     : 'CIVS_DESCRIPTION',
        modifierUserId  : 'CIVS_MODIFIER',
        modificationTime: 'CIVS_MODIFICATION_TIME',
        uuid            : 'CIVS_UUID'
    }
};

export default tableDefinition;
